import React from "react"

export default function Bell() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <g clipPath="url(#clip0_0_8)">
        <path d="M9.2002 16.5C10.0252 16.5 10.7002 15.825 10.7002 15H7.7002C7.7002 15.825 8.3677 16.5 9.2002 16.5ZM13.7002 8.25C13.7002 5.9475 12.4702 4.02 10.3252 3.51V3C10.3252 2.3775 9.8227 1.875 9.2002 1.875C8.5777 1.875 8.0752 2.3775 8.0752 3V3.51C7.8952 3.555 7.7227 3.6225 7.5577 3.6825L13.7002 9.825V8.25ZM4.2577 2.5125L3.2002 3.57L5.3077 5.6775C4.9177 6.4275 4.7002 7.2975 4.7002 8.25V12L3.7327 12.9675C3.2602 13.44 3.5902 14.25 4.2577 14.25H13.8802L15.1852 15.555L16.2427 14.4975L4.2577 2.5125Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_0_8">
          <rect width="18" height="18" fill="white" transform="translate(0.200195)" />
        </clipPath>
      </defs>
    </svg>
  )
}